import React from "react";
import { useNavigate } from "react-router-dom";

// Custom.
import Layout from "containers/Layout/Layout";
import { EnhancedTable } from "@vocollege/components";
import {
  GET_GROUPS,
  DELETE_GROUP,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  EnhancedTableStatusCell,
  EnhancedTableUserActive,
} from "@vocollege/components";

const Queues: React.FC = () => {
  let navigate = useNavigate();

  const editItem = (id = "create") => {
    navigate(`/groups/${id}`);
  };

  const getFilters = () => {
    return [
      {
        name: "status",
        label: I18n.get.form.labels.status,
        default: ["all"],
        values: [
          { label: I18n.get.actions.showAll, value: "all" },
          { label: I18n.get.status.published, value: "1" },
          { label: I18n.get.status.unpublished, value: "0" },
        ],
      },
      {
        name: "vopage",
        label: I18n.get.group.labels.vopage,
        default: ["all"],
        values: [
          { label: I18n.get.actions.showAll, value: "all" },
          { label: I18n.get.actions.yes, value: "1" },
          { label: I18n.get.actions.no, value: "0" },
        ],
      },
      {
        name: "category",
        label: I18n.get.form.labels.category,
        default: ["all"],
        multiple: true,
        values: [
          { label: I18n.get.actions.showAll, value: "all" },
          ...Object.keys(I18n.get.group.categories).map((category: string) => ({
            label: I18n.get.group.categories[category],
            value: category,
          })),
        ],
      },
    ];
  };

  return (
    <Layout>
      <EnhancedTable
        // client={client}
        className="vo-global__top-bottom-space"
        enableSearch
        title={I18n.get.group.labels.groups}
        operations={{
          category: "groups",
          get: GET_GROUPS,
          delete: DELETE_GROUP,
        }}
        columns={[
          { title: "ID", field: "id", width: 50 },
          {
            title: I18n.get.form.labels.status,
            field: "status",
            width: 120,
            render: (data) => <EnhancedTableStatusCell data={data.status} />,
          },
          {
            title: I18n.get.group.labels.vopage,
            field: "vopage",
            width: 120,
            render: (data) => <EnhancedTableUserActive data={data.vopage} />,
          },
          { title: I18n.get.form.labels.name, field: "name", width: 150 },
          { title: I18n.get.form.labels.title, field: "title", width: 150 },
          {
            title: I18n.get.form.labels.category,
            field: "category",
            width: 150,
            render: (data) => I18n.get.group.categories[data?.category],
          },
          {
            title: I18n.get.misc.created_at,
            field: "created_at",
            width: 200,
          },
          {
            title: I18n.get.misc.updated_at,
            field: "updated_at",
            width: 200,
          },
        ]}
        addItem={editItem}
        editItem={editItem}
        orderBy="UPDATED_AT"
        order="DESC"
        filters={getFilters()}
      ></EnhancedTable>
    </Layout>
  );
};

export default Queues;
